import Product from "@/models/product";
import http from "@/services/http-common";

class InstagramService {
    post(product: Product) {
        return http.post("/instagram/posts", { product })
    }
}
export default new InstagramService();